import { render, staticRenderFns } from "./AllHistoryDelivery.vue?vue&type=template&id=8b6b5a2e"
import script from "./AllHistoryDelivery.vue?vue&type=script&lang=js"
export * from "./AllHistoryDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports